import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import {
    PDFDownloadLink,
    Page,
    Text,
    View,
    Image,
    Document,
    StyleSheet,
    Link
} from "@react-pdf/renderer";
import Moment from 'moment';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { getUser } from 'Utils/storage';
import { AWL, DEEPAK_PHENOLICS, GALAXY_SURFACE } from 'Constants/commonConstants';
import { isAdaniWilmar, isFosroc } from 'Utils/index';
import Adani from 'Icons/adani.png';

const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff",
        marginTop: 10,
        marginBottom: 10
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        backgroundColor: "#f6f6f5",
        borderColor: 'black',
        borderWidth: 1,
        padding: 10,
        marginTop: 10,
        marginBottom: 10
    },
    text: { fontSize: 20, color: 'black', margin: 10, textAlign: 'center' },
    normalText: { fontSize: 12, color: 'black', padding: 5, borderColor: 'black', borderWidth: 1 },
    subtitle: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "col",
        width: 150,
        alignItems: "center",
        marginBottom: 12
    },
    detailsFooter: {
        display: "flex",
        flexDirection: "row"
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        margin: 10
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
    },
    tableColHeader: {
        width: "25%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderBottomColor: '#000',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableColHeaderOther: {
        width: "20%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderBottomColor: '#000',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableColOther: {
        width: "20%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCellHeader: {
        margin: "auto",
        margin: 5,
        fontSize: 12,
        fontWeight: 500
    },
    tableCell: {
        margin: "auto",
        margin: 5,
        fontSize: 10
    },
    image: {
        width: 80,
        height: 50
    }
});


class ComponentToPrint extends Component {
    render() {
        const { rfqDetails, rfqTripRecords, productCategories, selectedSeekerDetails } = this.props;
        const value = rfqTripRecords;
        const transName = value && value.length > 0 ? value[0].transporter_name : '';
         const panNo = value && value.length > 0 ? value[0].pan_number : '';
        return (
            <div className="col-12 transporter-detail">
                <div className="flex">
                    <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15">REF RFQ : </div>
                    <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15">{rfqDetails.rfq_number} </div>
                </div>
                <div className="flex contract-details-container-inner-header">
                    <div className="fBold fs-16 pt-10 pb-10 pl-15">Company Name : </div>
                    <div className="fBold fs-16 pt-10 pb-10 pl-15">{rfqDetails.company_name}
                        {selectedSeekerDetails && selectedSeekerDetails.formerly_note && <><br/><span>{`(${selectedSeekerDetails.formerly_note})`}</span></>}
                    </div>
                </div>
                
                <div className="trip-details-container">         
                    <div className="flex" >
                    <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15">To : </div>
                     <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15">{transName}</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15">Pan Number : </div>
                    <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15">{panNo}</div>
                </div>
                <div className="trip-details-container">
                    <div className="service-contracts-details">
                        <div className="flex contract-period-container">
                            <div className="fBold contract-period-container-inner fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">Contract Period</div>
                            <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">From : {Moment(rfqDetails.contract_tenure_from).format('Do MMM, YYYY')}</div>
                            {(rfqDetails && rfqDetails.rfq_type !== 9) && <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">To : {Moment(rfqDetails.contract_tenure_to).format('Do MMM, YYYY')}</div>}
                        </div>
                        <div className="flex service-type-container">
                            <div className="fBold contract-period-container-inner fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">Service Type</div>
                            <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">{rfqDetails.service_type_name}</div>
                        </div>
                        {DEEPAK_PHENOLICS.includes(getUser().companyId) && 
                        <div className="flex service-type-container">
                            <div className="fBold contract-period-container-inner fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">Product Category</div>
                            <div className="fBold fs-16 header-dark-color pt-10 pb-10 pl-15 wt-200">{rfqDetails.product_category && ((productCategories || []).find(product => product.value === rfqDetails.product_category) || {}).name || ''}</div>
                        </div>
                        }
                    </div>
                    <div className="contract-details-container">
                        <div className="flex">
                            <div className="fBold col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Movement</div>
                            {(rfqDetails && rfqDetails.rfq_type !== 9) && <>
                            <div className="fBold col-2 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-300 contract-details-container-inner-header">Operation</div>
                            <div className="fBold col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Transit Days</div>
                            </>}
                            {(rfqDetails && rfqDetails.rfq_type === 9) && <div className="fBold col-2 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-300 contract-details-container-inner-header">Quantity</div>}
                            <div className="fBold col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Pricing Basis</div>
                            {rfqDetails && rfqDetails.rfq_type !== 5 && <div className="fBold col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Price</div>}
                            {rfqDetails && rfqDetails.rfq_type === 5 && <div className="fBold col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Price INR(₹)</div>}
                           {rfqDetails && rfqDetails.rfq_type === 5 && <div className="fBold col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Price USD($)</div>}
                           {isFosroc() && <div className="fBold col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">LOI Approval Details</div>}
                        </div>
                        {(value || []).map((rfqTrip, index) => {
                            return (
                                <div className="flex" key={index}>
                                    <div className="col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{(rfqTrip.stops || []).length > 2 ? <>
                                    {
                                        (rfqTrip.stops || []).map((stop, index)=> {
                                            return (
                                                <span>{(stop.location && (stop.location.split(',') || [])[0] || stop.city)}{(((rfqTrip.stops || []).length - 1) !== index) ? <BackIcon className="wt-10 ml-5 mr-5 mt-5 rotate-180deg" /> : ''}</span>
                                            )
                                        })
                                    }
                                    </> :<>{rfqTrip.from} - {rfqTrip.to}</>}</div>
                                    {(rfqDetails && rfqDetails.rfq_type !== 9) && <>
                                    <div className="col-2 header-dark-color fBold pt-10 pb-10 pl-15 pr-10 wt-300 contract-details-container-inner">{rfqTrip.vehicle_type_name} ({rfqTrip.vehicle_body_type_name})</div>
                                    <div className="col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{rfqTrip.tat && rfqTrip.tat.value ? <span>{rfqTrip.tat.value || ''} {rfqTrip.tat.name}</span> : ''}</div>
                                    </>}
                                    {(rfqDetails && rfqDetails.rfq_type === 9) && <div className="col-2 header-dark-color fBold pt-10 pb-10 pl-15 pr-10 wt-300 contract-details-container-inner">{rfqTrip.quantity}</div>}
                                    <div className="col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{rfqTrip.pricing_basis}</div>
                                    {rfqDetails && rfqDetails.rfq_type !== 5 && <div className="col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{rfqTrip.price}</div>}
                                    {rfqDetails && rfqDetails.rfq_type === 5 &&<div className="col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{rfqTrip.price_inr}</div>}
                                    {rfqDetails && rfqDetails.rfq_type === 5 &&<div className="col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{rfqTrip.price_usd}</div>}
                                    {isFosroc() && <div className="col-4 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">
                                        {(rfqTrip.bid_approved_status || []).map((el) => (<>
                                        <div>{((((rfqDetails['approver_names'] || []).find(approver => approver.email === (el.approved_by ? el.approved_by : ((rfqTrip.bid_approver_emails || []).join(''))))) || {}).user_name || '')}</div>
                                        <div>{`(${el.loi_approved_date && Moment(el.loi_approved_date).format('DD MMM YYYY HH:mm')})`}</div></>))}
                                    </div>}
                                </div>
                            )
                        })}
                    </div>
                    {rfqDetails && rfqDetails.rfq_type === 5 &&<div className="contract-details-container">
                        <div className="flex">
                            <div className="fBold col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Cost Head</div>
                            <div className="fBold col-2 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-300 contract-details-container-inner-header">Cost Heading Desc</div>
                            <div className="fBold col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Bid Rate INR(₹)</div>
                            <div className="fBold col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner-header">Bid Rate USD($)</div>
                        </div>
                        {(value || []).map((rfqTrip, index) => {
                            return (
                                (rfqTrip.multi_mode_heading_charges || []).map((headCost, id)=>{
                                    return(
                                <div className="flex" key={id}>
                                    <div className="col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{headCost.headingChargesValue}</div>
                                    <div className="col-2 header-dark-color fBold pt-10 pb-10 pl-15 pr-10 wt-300 contract-details-container-inner">{headCost.headingChargesDescription}</div>
                                    <div className="col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{headCost.headingChargesCp_inr}</div>
                                    <div className="col-3 header-dark-color pt-10 pb-10 pl-15 pr-10 wt-200 contract-details-container-inner">{headCost.headingChargesCp_usd}</div>
                                </div>
                                    )
                              })
                            )
                        })}
                    </div>}
                </div>
            </div>
        );
    }
}


class PrintDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ele: null,
        }
    }
    componentDidMount() {
        this.renderPDFDom(this.props.rfqTripRecords, this.props.rfqDetails);
    }

    UNSAFE_componentWillReceiveProps (newProps) {
        this.renderPDFDom(newProps.rfqTripRecords, newProps.rfqDetails);
    }

    openViewLoiDetails = () => {
        const { rfqTripRecords, rfqDetails, history } = this.props;
        const firstTrip = (rfqTripRecords || [])[0] || {};
        const rfqId = firstTrip.rfq_id;
        const transporterId = firstTrip.transporter_id || "0";
        const rfqType = rfqDetails.rfq_type;
        const seekerCompanyId = rfqDetails.company_id || 0;
        history.push(`/contractRecords/loi-details/${rfqId}/${transporterId}/${rfqType}/${rfqDetails.status}/${seekerCompanyId}`);
    }

    renderPDFDom = (rfqTripRecords=this.props.rfqTripRecords, rfqDetails=this.props.rfqDetails) => {
        const { gettingTrips, productCategories } = this.props;
        let ele = null;
        if (Document) {
            ele = (
                <Document>
                    <Page size="A4" style={styles.page} wrap>
                        <View style={styles.section}>
                            <Text style={styles.text}>{rfqDetails.company_name}</Text>
                            <View style={styles.table} >
                                <View style={styles.tableRow}>
                                <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: (rfqDetails || {}).rfq_type === 9 ? "18%" : "12%"}]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>{(rfqDetails || {}).rfq_type === 9 ? 'Buyer' : 'Transporter'}</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: "14%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Floated On</Text>
                                    </View>
                                    {((rfqDetails || {}).rfq_type !== 9) && <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: "14%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Contract Tenture</Text>
                                    </View>}
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width:(rfqDetails || {}).rfq_type === 9 ? '34%' : "14%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Bidding Time</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width:(rfqDetails || {}).rfq_type === 9 ? "20%" : "18%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>RFQ No</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: (rfqDetails || {}).rfq_type === 9 ? "14%" : "10%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Insurance By</Text>
                                    </View>
                                    {(rfqDetails || {}).rfq_type !== 9 && <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: "10%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Service Type</Text>
                                    </View>}
                                    {(rfqDetails || {}).rfq_type !== 9 && <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: "12%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Movement Type</Text>
                                    </View>}
                                    {DEEPAK_PHENOLICS.includes(getUser().companyId) && 
                                        <View style={[styles.tableColHeader, { backgroundColor: '#528aea', width: "12%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 12 }]}>Product Category</Text>
                                    </View>}
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableColHeader, { width: (rfqDetails || {}).rfq_type === 9 ? "18%" : "12%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{rfqTripRecords && (rfqTripRecords || []).length > 0 && (rfqTripRecords[0] || {}).transporter_name || ''}</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { width: "14%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{Moment(rfqDetails.created).format("Do MMM, YYYY")}</Text>
                                    </View>
                                    {((rfqDetails || {}).rfq_type !== 9) && <View style={[styles.tableColHeader, { width: "14%" }]}>
                                        {rfqDetails.rfq_type !== 9 ? <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{Moment(rfqDetails.contract_tenure_from).format("Do MMM, YYYY")} - {Moment(rfqDetails.contract_tenure_to).format("Do MMM, YYYY")}</Text> :
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{Moment(rfqDetails.contract_tenure_from).format("Do MMM, YYYY")}</Text>}
                                    </View>}
                                    <View style={[styles.tableColHeader, { width:(rfqDetails || {}).rfq_type === 9 ? "34%" : "14%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{Moment(rfqDetails.bidding_start).format('Do MMM, YYYY h:mm:ss a')} - {Moment(rfqDetails.bidding_end).format('Do MMM, YYYY h:mm:ss a')}</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { width: (rfqDetails || {}).rfq_type === 9 ? "20%" : "18%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{rfqDetails.rfq_number}</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { width: (rfqDetails || {}).rfq_type === 9 ? "14%" : "10%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{rfqDetails.insurance_by_name}</Text>
                                    </View>
                                    {(rfqDetails || {}).rfq_type !== 9 && <View style={[styles.tableColHeader, { width: "10%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{rfqDetails.service_type_name}</Text>
                                    </View>}
                                    {(rfqDetails || {}).rfq_type !== 9 && <View style={[styles.tableColHeader, { width: "12%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{rfqDetails.movement_type_name}</Text>
                                    </View>}
                                    {DEEPAK_PHENOLICS.includes(getUser().companyId) && 
                                    <View style={[styles.tableColHeader, { width: "12%" }]}>
                                        <Text style={[styles.tableCellHeader, { fontSize: 10 }]}>{rfqDetails.product_category && ((productCategories || []).find(product => product.value === rfqDetails.product_category) || {}).name || ''}</Text>
                                    </View>}
                                </View>
                            </View>

                            <Text style={styles.text}>Trip Details</Text>
                            {rfqDetails.rfq_type !== 9 && <View style={styles.table} >
                                <View style={styles.tableRow} fixed>
                                    <View style={[(rfqDetails && rfqDetails.rfq_type === 5 )?styles.tableColHeaderOther :styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Movement</Text>
                                    </View>
                                    <View style={[(rfqDetails && rfqDetails.rfq_type === 5 )?styles.tableColHeaderOther :styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Operation</Text>
                                    </View>
                                    <View style={[(rfqDetails && rfqDetails.rfq_type === 5 )?styles.tableColHeaderOther :styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Pricing Basis</Text>
                                    </View>
                                    {rfqDetails && rfqDetails.rfq_type !== 5 &&
                                    <View style={[(rfqDetails && rfqDetails.rfq_type === 5 )?styles.tableColHeaderOther :styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Price</Text>
                                    </View>}
                                    {rfqDetails && rfqDetails.rfq_type === 5 &&
                                        <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Price INR(₹)</Text>
                                    </View>} 
                                    {rfqDetails && rfqDetails.rfq_type === 5 &&
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea' }]}>
                                    <Text style={styles.tableCellHeader}>Price USD($)</Text>
                                   </View> 
                                    }
                                    {isFosroc() &&
                                    <View style={[(rfqDetails && rfqDetails.rfq_type === 5 )?styles.tableColHeaderOther :styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>LOI Approval Details</Text>
                                    </View>}
                                </View>
                                {
                                    rfqTripRecords && Object.keys(rfqTripRecords).length > 0 && (rfqTripRecords || []).map((trip, index) => {
                                        return (
                                            <View style={styles.tableRow} key={index} wrap={false}>
                                                <View style={(rfqDetails && rfqDetails.rfq_type === 5 ) ? styles.tableColOther:styles.tableCol}>
                                                    <Text style={styles.tableCell}>{(trip.stops || []).length > 2 ? <>
                                                        {((trip.stops || []).map(stop => (stop.location && (stop.location.split(',') || [])[0] || stop.city)) || []).join(' -> ')}
                                                        </> :<>{trip.from} - {trip.to}</>}
                                                    </Text>
                                                </View>
                                                <View style={ (rfqDetails && rfqDetails.rfq_type === 5 ) ? styles.tableColOther:styles.tableCol}>
                                                    <Text style={styles.tableCell}>{trip.vehicle_type_name} ({trip.vehicle_body_type_name})</Text>
                                                </View>
                                                <View style={(rfqDetails && rfqDetails.rfq_type === 5 ) ? styles.tableColOther:styles.tableCol}>
                                                    <Text style={styles.tableCell}>{trip.pricing_basis}</Text>
                                                </View>
                                                {rfqDetails && rfqDetails.rfq_type !== 5 && <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{trip.price}</Text>
                                                </View>}
                                                {rfqDetails && rfqDetails.rfq_type === 5 &&  <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{trip.price_inr}</Text>
                                                </View>}
                                                {rfqDetails && rfqDetails.rfq_type === 5 &&  <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{trip.price_usd}</Text>
                                                </View>}
                                                {isFosroc() &&  <View style={styles.tableCol}>
                                                {(trip.bid_approved_status || []).map((el) => (<>
                                                    <Text style={styles.tableCell}>{((((rfqDetails['approver_names'] || []).find(approver => approver.email === (el.approved_by ? el.approved_by : ((rfqTrip.bid_approver_emails || []).join(''))))) || {}).user_name || '')}</Text>
                                                    <Text style={styles.tableCell}>{`(${el.loi_approved_date && Moment(el.loi_approved_date).format('DD MMM YYYY HH:mm')})`}</Text></>))}
                                                </View>}

                                            </View>
                                        )
                                    })
                                }
                            </View>}
                            {rfqDetails && rfqDetails.rfq_type === 9 && 
                                <View style={styles.table} >
                                <View style={styles.tableRow}>
                                    {rfqDetails.disposal_contract_type === 1 ? <>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '15%' }]}>
                                        <Text style={styles.tableCellHeader}>Depot Name</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '10%' }]}>
                                        <Text style={styles.tableCellHeader}>Depot Code</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '15%' }]}>
                                        <Text style={styles.tableCellHeader}>Material Name</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '12%' }]}>
                                        <Text style={styles.tableCellHeader}>Material code</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '10%' }]}>
                                        <Text style={styles.tableCellHeader}>Quantity</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '8%' }]}>
                                        <Text style={styles.tableCellHeader}>Rate</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '10%' }]}>
                                        <Text style={styles.tableCellHeader}>Pricing Basis</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '10%' }]}>
                                        <Text style={styles.tableCellHeader}>Price</Text>
                                    </View>
                                    <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '10%' }]}>
                                        <Text style={styles.tableCellHeader}>lifting Tenure</Text>
                                    </View>
                                    </> : 
                                    <>
                                        <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '10%' }]}>
                                            <Text style={styles.tableCellHeader}>Sl No.</Text>
                                        </View>
                                        <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '30%' }]}>
                                            <Text style={styles.tableCellHeader}>Zone</Text>
                                        </View>
                                        <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '30%' }]}>
                                            <Text style={styles.tableCellHeader}>Price</Text>
                                        </View>
                                        <View style={[styles.tableColHeaderOther, { backgroundColor: '#528aea', width: '30%' }]}>
                                            <Text style={styles.tableCellHeader}>Lifting Tenure</Text>
                                        </View>
                                    </>
                                    }
                                </View>
                                {
                                    rfqTripRecords && Object.keys(rfqTripRecords).length > 0 && (rfqTripRecords || []).map((trip, index) => {
                                        const isDepotWise = (rfqDetails.disposal_contract_type === 1);
                                        return (
                                            <>
                                            {!isDepotWise && 
                                                <>
                                                <View style={styles.tableRow} key={`zone-${index}`}>
                                                    <View style={[styles.tableCol, {width: '10%', backgroundColor: '#d4f2ff'}]}>
                                                        <Text style={styles.tableCell}>{index + 1}</Text>
                                                    </View>
                                                    <View style={[styles.tableCol, {width: '30%', backgroundColor: '#d4f2ff'}]}>
                                                        <Text style={styles.tableCell}>{trip.zone}</Text>
                                                    </View>
                                                    <View style={[styles.tableCol, {width: '30%', backgroundColor: '#d4f2ff'}]}>
                                                        <Text style={styles.tableCell}>{trip.price}</Text>
                                                    </View>
                                                    <View style={[styles.tableCol, {width: '30%', backgroundColor: '#d4f2ff'}]}>
                                                        <Text style={styles.tableCell}>{(trip.contract_tenure_from && trip.contract_tenure_to) && `${Moment(trip.contract_tenure_from).format("Do MMM, YYYY")} - ${Moment(trip.contract_tenure_to).format("Do MMM, YYYY")}` || ''}</Text>
                                                    </View>
                                                </View>
                                                </>
                                            }
                                            <>
                                            {rfqTripRecords && Object.keys(trip).length > 0 && ((trip.sub_disposal_trip || trip.sub_trip_disposal_product) || []).map((subTrip, id) => {
                                                return(
                                                    <>
                                                    {isDepotWise ? 
                                                    <>
                                                    <View style={styles.tableRow} key={id}>
                                                        <View style={[styles.tableCol, {width: '15%'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.depo_name}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.from}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '15%', 'wordBreak': 'break-word'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.material_code_description}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '12%'}]}>
                                                            <Text style={[styles.tableCell, {'wordBreak': 'break-word'}]}>{subTrip.to}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.quantity}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '8%'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.price}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.pricing_basis}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                            <Text style={styles.tableCell}>{subTrip.bid_quantity_cost}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                            <Text style={styles.tableCell}>{Moment(trip.contract_tenure_from).format("Do MMM, YYYY")} - {Moment(trip.contract_tenure_to).format("Do MMM, YYYY")}</Text>
                                                        </View>
                                                    </View>
                                                    </> : 
                                                    <>
                                                        {/* {(id == 0) && <View style={styles.tableRow}>
                                                            <View style={[styles.tableColHeaderOther, { backgroundColor: "#486aa3", width: '30%', color: 'white' }]}>
                                                                <Text style={styles.tableCellHeader}>Material Description</Text>
                                                            </View>
                                                            <View style={[styles.tableColHeaderOther, { backgroundColor: "#486aa3", width: '20%', color: 'white' }]}>
                                                                <Text style={styles.tableCellHeader}>Quantity</Text>
                                                            </View>
                                                            <View style={[styles.tableColHeaderOther, { backgroundColor: "#486aa3", width: '15%', color: 'white' }]}>
                                                                <Text style={styles.tableCellHeader}>Rate</Text>
                                                            </View>
                                                            <View style={[styles.tableColHeaderOther, { backgroundColor: "#486aa3", width: '20%', color: 'white' }]}>
                                                                <Text style={styles.tableCellHeader}>Pricing Basis</Text>
                                                            </View>
                                                            <View style={[styles.tableColHeaderOther, { backgroundColor: "#486aa3", width: '15%', color: 'white' }]}>
                                                                <Text style={styles.tableCellHeader}>Price</Text>
                                                            </View>
                                                        </View>}
                                                        <View style={styles.tableRow} key={id}>
                                                            <View style={[styles.tableCol, {width: '30%'}]}>
                                                                <Text style={styles.tableCell}>{subTrip.material_code_description}</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, {width: '20%'}]}>
                                                                <Text style={styles.tableCell}>{subTrip.quantity}</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, {width: '15%'}]}>
                                                                <Text style={styles.tableCell}>{subTrip.price}</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, {width: '20%'}]}>
                                                                <Text style={styles.tableCell}>{subTrip.pricing_basis || trip.pricing_basis || 'KG'}</Text>
                                                            </View>
                                                            <View style={[styles.tableCol, {width: '15%'}]}>
                                                                <Text style={styles.tableCell}>{subTrip.quantity_cost}</Text>
                                                            </View>
                                                        </View> */}
                                                        {
                                                            <>
                                                            {(subTrip.disposal_material_trip || []).map((disposalTrip, dIndex) => {
                                                                return (
                                                                    <>
                                                                    {dIndex === 0 && <View style={styles.tableRow}>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '25%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Material</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '20%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Depot Name</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '10%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Depot Code</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '10%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Quantity</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '10%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Rate</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '10%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Pricing Basis</Text>
                                                                        </View>
                                                                        <View style={[styles.tableColHeaderOther, { backgroundColor: "#5675a8", width: '15%', color: 'white' }]}>
                                                                            <Text style={styles.tableCellHeader}>Price</Text>
                                                                        </View>
                                                                    </View>}
                                                                    <View style={styles.tableRow} key={`d-${dIndex}`}>
                                                                        <View style={[styles.tableCol, {width: '25%'}]}>
                                                                            <Text style={styles.tableCell}>{dIndex === 0 ? subTrip.material_code_description : ''}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, {width: '20%'}]}>
                                                                            <Text style={styles.tableCell}>{disposalTrip.depo_name}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                                            <Text style={styles.tableCell}>{disposalTrip.depo_code || disposalTrip.from}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                                            <Text style={styles.tableCell}>{disposalTrip.quantity}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                                            <Text style={styles.tableCell}>{disposalTrip.price}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, {width: '10%'}]}>
                                                                            <Text style={styles.tableCell}>{disposalTrip.pricing_basis_name || disposalTrip.pricing_basis || "KG"}</Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, {width: '15%'}]}>
                                                                            <Text style={styles.tableCell}>{disposalTrip.bid_quantity_cost}</Text>
                                                                        </View>
                                                                    </View>
                                                                    </>
                                                                )
                                                            })}
                                                            </>
                                                        }
                                                    </>}
                                                    </>
                                                 )
                                                 })
                                                }</></>
                                        )
                                    })
                                }
                                
                            </View> 
                            }
                            {(GALAXY_SURFACE.includes(rfqDetails.company_id) && (rfqDetails.docs || []).length > 0) && <View>
                                <View style={[{ marginLeft: '10px', marginTop: '10px' }]}>
                                <Text style={[{ fontSize: 12, marginTop: '5px' }]}>Terms and Conditions</Text>
                                {(rfqDetails.docs || []).map((val, index) =><Text style={[{ fontSize: 12, marginTop: '5px' }]}>{index + 1}. <Link src={val.url} id={val.name}>{val.name}</Link></Text>)}
                            </View>
                            </View>}
                            {(isAdaniWilmar() && rfqDetails && rfqDetails.rfq_type === 9) && <View>
                                <View style={[{ marginLeft: '10px', marginTop: '10px' }]}>
                                    <Text style={[{ fontSize: 10, marginTop: '5px' }]}>Regards,</Text>
                                    <Text style={[{ fontSize: 10, marginTop: '5px' }]}>{getUser().companyName}</Text>
                                    <Image style={styles.image} src={Adani} cache={false} />
                                </View>
                            </View>}
                            {rfqDetails && rfqDetails.rfq_type === 5 && <View style={styles.table} >
                                <View style={styles.tableRow} fixed>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Cost Head </Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Cost Heading Desc</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Bid Rate INR(₹)</Text>
                                    </View>
                                    <View style={[styles.tableColHeader, { backgroundColor: '#528aea' }]}>
                                        <Text style={styles.tableCellHeader}>Bid Rate USD($)</Text>
                                    </View>
                                   
                                </View>
                                {
                                    rfqTripRecords && Object.keys(rfqTripRecords).length > 0 && (rfqTripRecords || []).map((trip, index) => {
                                        return (
                                            rfqTripRecords && Object.keys(trip).length > 0 && (trip.multi_mode_heading_charges || []).map((cost, id) => {
                                           return(
                                            <View style={styles.tableRow} key={id} wrap={false}>
                                                <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{cost.headingChargesValue}</Text>
                                                </View>
                                                <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{cost.headingChargesDescription}</Text>
                                                </View>
                                                <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{cost.headingChargesCp_inr}</Text>
                                                </View>
                                                <View style={styles.tableCol}>
                                                    <Text style={styles.tableCell}>{cost.headingChargesCp_usd}</Text>
                                                </View>

                                            </View>
                                           )
                                            })
                                        )
                                    })
                                }
                            </View>}
                        </View>
                    </Page>
                </Document>
            );
        }
        this.setState({ ele });
    }
    render() {
        const { rfqDetails, rfqTripRecords, productCategories, onDownloadExcel, onDownloadTC } = this.props;
        return (
            <div className="print-trips-container">
                <ReactToPrint
                    trigger={() => <button className="br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10">Print</button>}
                    content={() => this.componentRef}
                />
                <div style={{ display: "none" }}>
                    <ComponentToPrint ref={el => (this.componentRef = el)} rfqDetails={rfqDetails} rfqTripRecords={rfqTripRecords} productCategories={productCategories || []}/>
                </div>
                <PDFDownloadLink
                    document={this.state.ele}
                    fileName="triplist.pdf"
                    style={{
                        textDecoration: "none",
                        padding: "10px 20px",
                        color: "white",
                        backgroundColor: "#528aea",
                        border: "1px solid #528aea",
                        borderRadius: "20px",
                        fontWeight: 900,

                    }}
                >
                    {({ blob, url, loading, error }) =>
                        loading ? 'Loading Document' : "Download PDF"
                    }
                </PDFDownloadLink>
                {AWL.includes(rfqDetails.company_id) && rfqDetails.rfq_type==15 && <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10" onClick={this.openViewLoiDetails}>View LOI Details</button>}
                {GALAXY_SURFACE.includes(getUser().companyId) && <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10" onClick={() =>onDownloadExcel(rfqTripRecords)}>Download Excel</button>}
                {isFosroc() && <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10" onClick={onDownloadTC}>Download T&C</button>}
            </div>
        );
    }
}

export default PrintDetails;
